// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress-ring{position:relative;display:inline-block}.progress-ring__layer{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center}.progress-ring__circle{transition:350ms stroke-dashoffset}", ""]);
// Exports
module.exports = exports;
